import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { EnumAcaoRecurso } from 'src/app/models/enum/acao-recurso.enum';
import { EnumRecursoPerfil } from 'src/app/models/enum/recurso-perfil.enum';
import { IPermissaoModel } from 'src/app/models/permissao.model';
import { AuthService } from 'src/app/services/auth.service';
import { BaseListComponent } from 'src/app/shared/components/base-list/base-list.component';
import { IRiscosChavesListaModel } from 'src/app/models/riscos-chaves-lista.model';
import { RiscosChavesServices } from 'src/app/services/riscos-chaves.service';
import { SharedService } from 'src/app/services/shared.service';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { UnidadeGestoraService } from 'src/app/services/unidade-gestora.service';
import { QuestionarioUGService } from 'src/app/services/questionarioug.service';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { Route } from '@angular/router';
import { FiltroRiscosChavesModel } from "../../../models/filtro-riscos-chaves.model";
import {
  EUniversoAuditavelSituacao,
  EUniversoAuditavelSituacaoDescricao
} from "../../../models/enum/universo-auditavel-situacao";
import {
  ModalSolicitarPreenchimentoUniversoComponent
} from "../aba-universo-auditavel/modal-solicitar-preenchimento/modal-solicitar-preenchimento.component";
import {
  ModalSolicitarPreenchimentoRiscosChavesComponent
} from "./modal-solicitar-preenchimento/modal-solicitar-preenchimento.component";
import { ERiscosChavesSituacao, ERiscosChavesSituacaoDescricao } from "../../../models/enum/riscos-chaves-situacao";
import {
  ModalSelecaoUniversoAuditavelComponent
} from "./modal-selecao-universo-auditavel/modal-selecao-universo-auditavel.component";
import { FiltroUniversoAuditavel } from "../../../models/filtro-universo-auditavel";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { saveAs } from "file-saver";
import { ITipoUniversoModel } from "../../../models/tipo-universo.model";
import { IUniversoAuditavelModel } from "../../../models/universo-auditavel.model";
import { UniversoAuditavelService } from "../../../services/universo-auditavel.service";


const normalizeString = (str) => {
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[()]/g, " ")
    .toLowerCase();
};

const sortingDataAccessor = (item, property) => {
  switch (property) {
    case 'versao': return item.versao.trim().toLowerCase();
    case 'dataCriacaoFormatada': return item.dataCriacaoFormatada.trim().toLowerCase();
    case 'situacao': return item.situacao.trim().toLowerCase();
    case 'ativo':
      return item.ativo;
    case 'nomeTipoUniverso':
      return normalizeString(item.nomeTipoUniverso.trim());
    default:
      return item.nomeTipoUniverso.trim().toLowerCase();
  }
};

@Component({
  selector: 'app-aba-riscos-chaves',
  templateUrl: './aba-riscos-chaves.component.html',
  styleUrls: ['./aba-riscos-chaves.component.scss']
})
export class AbaRiscosChavesComponent extends BaseListComponent {

  public dataSource = new MatTableDataSource<IRiscosChavesListaModel>([]);
  public selectedModel: IRiscosChavesListaModel;
  public displayedColumns: string[] = ['selecao', 'versao', 'nomeTipoUniverso', 'dataCriacaoFormatada', 'situacao', 'status'];
  public nomeTipoUniverso: string;
  public searchNome: string;
  public searchAtivo = true;
  public semDados = true;
  public permissoes: IPermissaoModel;
  public filtro = {} as FiltroRiscosChavesModel;
  public filtroUniverso = {} as FiltroUniversoAuditavel;
  public totalItens: number;
  public pageEvent: any;
  public unidadeGestoraId: number;
  private currentDialogRef: MatDialogRef<any>;
  tipoUniversoId: number;
  tipoUniverso: number;
  universoAuditavelId: number;

  public botaoNovoDisable = false;
  public botaoEditarDisable = false;
  public botaoExcluirDisable = false;
  public botaoImprimirDisable = false;
  public botaoPreenchimentoDisable = false;
  public botaoImportarDisable = false;
  public botaoVisualizarDisable = false;
  public isPreencherDisabled = false;
  public universoSelecionado = false;
  public universoFilter: IUniversoAuditavelModel[];

  @ViewChild('TableOnePaginator', { static: true }) tableOnePaginator: MatPaginator;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private authService: AuthService,
    private http: HttpClient,
    private riscosChavesService: RiscosChavesServices,
    private matDialog: MatDialog,
    private questionarioUGService: QuestionarioUGService,
    private route: ActivatedRoute,
    private router: Router,
    private unidadeGestoraService: UnidadeGestoraService,
    private universoAuditavelService: UniversoAuditavelService,
    private sharedService: SharedService
  ) {
    super();
  }

  async ngOnInit() {
    this.setarPermissoes();
    this.filtroUniverso.ativo = true;
    this.filtroUniverso.unidadeGestoraId = this.sharedService.getId();
    this.filtroUniverso.itensPorPagina = 30;
    this.filtroUniverso.colunaOrder = 'nomeTipoUniversoAuditavel';
    await this.configurarFiltro();
     await this.buscar();
  }

  private setarPermissoes(): void {
    this.permissoes = new IPermissaoModel();
    // this.permissoes.consultar = this.authService.possuiPermissao(EnumRecursoPerfil.QuestionarioEntentendoEntidade, EnumAcaoRecurso.Consultar);
    this.permissoes.editar = this.authService.possuiPermissao(EnumRecursoPerfil.QuestionarioEntentendoEntidade, EnumAcaoRecurso.Editar);
    this.permissoes.excluir = this.authService.possuiPermissao(EnumRecursoPerfil.QuestionarioEntentendoEntidade, EnumAcaoRecurso.Excluir);
    // this.permissoes.inativarReativar = this.authService.possuiPermissao(EnumRecursoPerfil.QuestionarioEntentendoEntidade, EnumAcaoRecurso.AtivarInativar);
    this.permissoes.incluir = this.authService.possuiPermissao(EnumRecursoPerfil.QuestionarioEntentendoEntidade, EnumAcaoRecurso.Inserir);
    this.permissoes.visualizar = this.authService.possuiPermissao(EnumRecursoPerfil.QuestionarioEntentendoEntidade, EnumAcaoRecurso.Visualizar);
    this.permissoes.imprimir = this.authService.possuiPermissao(EnumRecursoPerfil.QuestionarioEntentendoEntidade, EnumAcaoRecurso.Imprimir);
    this.permissoes.importar = this.authService.possuiPermissao(EnumRecursoPerfil.QuestionarioEntentendoEntidade, EnumAcaoRecurso.Importar);

  }

  async ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sortingDataAccessor = sortingDataAccessor;
  }

  public novo() {

    // if (!this.semDados) {
    //   const dialogConfig = new MatDialogConfig();
    //   dialogConfig.id = 'modal-component';
    //   dialogConfig.width = '650px';
    //   dialogConfig.hasBackdrop = true;
    //   dialogConfig.disableClose = true;
    //   dialogConfig.data = {
    //     source: 'novo'
    //   };
    //   //this.currentDialogRef = this.matDialog.open(ModalQuestionarioNovaVersaoComponent, dialogConfig);
    //   this.currentDialogRef.afterClosed().subscribe((data) => {
    //     this.buscar();
    //   });
    // } else {

      this.router.navigate([`/gerar`]);

    // }
  }

  public async buscar() {
    console.log(this.filtro);
    this.selectedModel = null;
    this.riscosChavesService
      .obter(this.filtro)
      .then((res) => {
        this.totalItens = res.dados.totalItens;
        this.dataSource = new MatTableDataSource<IRiscosChavesListaModel>(res.dados.resultado);
        this.totalItens = res.dados.totalItens;
        this.paginator = this.tableOnePaginator;
        this.dataSource.sort = this.sort;
        this.dataSource.sortingDataAccessor = sortingDataAccessor;
        this.dataSource._updateChangeSubscription();
        this.semDados = this.dataSource.filteredData.length === 0;
      })
      .catch((err) => {
        this.exibirMensagemErro(err.mensagem);
      })
  }

  public selecionar(row: any) {
	  const fakeEvent = { checked: true } as MatCheckboxChange;
	  this.handleCheckboxChange(fakeEvent, row);
  }

  handleCheckboxChange(event: MatCheckboxChange, element: any): void {
    this.selectedModel = event.checked ? element : null;
    if (!!element.arquivoId  && event.checked) {
      this.botaoEditarDisable = true;
      this.botaoVisualizarDisable = true;
      this.botaoNovoDisable = true;
      this.isPreencherDisabled = true;

    } else {
      this.botaoEditarDisable = false;
      this.botaoVisualizarDisable = false;
      this.botaoNovoDisable = false;
      this.isPreencherDisabled = false;
    }

  }

  private  async configurarFiltro() {
    await this.universoAuditavelService.obter(this.filtroUniverso).then(res => {
      if(res.sucesso){
        this.universoFilter = res.dados.resultado;
      }
    });

    this.filtro.unidadeGestoraId = this.sharedService.getId();
    this.filtro.pagina = this.tableOnePaginator.pageIndex + 1;
    this.filtro.itensPorPagina = this.tableOnePaginator.pageSize;
    this.filtro.colunaOrder = this.sort.active;
    this.filtro.ativo = this.searchAtivo;
    this.filtro.pesquisa = this.searchNome;
    this.filtro.direcao = this.sort.direction;
  }

  sortData(sort) {
    this.filtro.colunaOrder = sort.active;
    this.filtro.direcao = sort.direction;

    this.buscar();
  }

  public selecionarTipoUniverso(element: IUniversoAuditavelModel){
    if(element){
      this.filtro.tipoUniversoAuditavelId = element.tipoUniversoAuditavelId;
    }else{
      this.filtro.tipoUniversoAuditavelId = null;
    }
    this.buscar();
  }

  pageChanged(e) {
    this.filtro.pagina = e.pageIndex + 1;
    e.pageIndex = this.filtro.pagina;
    this.filtro.itensPorPagina = e.pageSize;
    this.buscar();
  }

  public editar(id: number , acao: string) {
    if(!this.permissoes.editar){
      this.exibirMensagemErro("Você não possui permissão para esta ação.");
      return;
    }
    this.router.navigate([`/riscos-chaves-form/${id}`]);

    this.sharedService.setParams(
      this.unidadeGestoraId,
      id,
      this.tipoUniversoId,
      acao
    );
  }

  public solicitar(id: number) {
    if(this.selectedModel.arquivoId !== null && this.selectedModel.arquivoId !== undefined){
      return;
    }else{
      const situacoesPermitidas = [
        ERiscosChavesSituacaoDescricao[ERiscosChavesSituacao.EmElaboracao],
        ERiscosChavesSituacaoDescricao[ERiscosChavesSituacao.Avocado],
        ERiscosChavesSituacaoDescricao[ERiscosChavesSituacao.Expirado]
      ];
      const situacaoAtual = this.selectedModel.situacao;

      if(situacoesPermitidas.includes(situacaoAtual) && this.selectedModel.ativo == true){
        const dialogConfig = new MatDialogConfig();
        dialogConfig.id = 'modal-solicitar-preenchimento-risco-chaves';
        dialogConfig.width = '650px';
        dialogConfig.hasBackdrop = true;
        dialogConfig.disableClose = true;
        dialogConfig.data = {
          param1: id
        };

        this.currentDialogRef =  this.matDialog.open(ModalSolicitarPreenchimentoRiscosChavesComponent, dialogConfig);
        this.currentDialogRef.afterClosed().subscribe((data) => {
          this.buscar();
        });

      }
    }

  }

  isSelect() {
    if (this.selectedModel !== null) {
      return !this.selectedModel?.ativo;
    }
  }

  isDesabilitaTipoImportacao(): boolean {
    return !!this.selectedModel.arquivoId;
  }

  public preencher(id: number) {

    if(this.selectedModel.arquivoId !== null && this.selectedModel.arquivoId !== undefined){
      return;
    }else{
      const situacaoAtual = this.selectedModel.situacao;

      const situacoesNaoPermitidas = [
        EUniversoAuditavelSituacao[EUniversoAuditavelSituacao.Pendente],
        EUniversoAuditavelSituacao[EUniversoAuditavelSituacao.Finalizado],
      ];
      if (
        !situacoesNaoPermitidas.includes(situacaoAtual) &&
        this.selectedModel.ativo === true
      ){
        this.router.navigate([`/riscos-chaves-form/${id}`]);

        this.sharedService.setParams(
          this.unidadeGestoraId,
          id,
          this.tipoUniversoId,
          'preecher'
        );
      }else{
        this.exibirMensagemAlerta(
          "Risco chaves só pode ser preenchido se estiver com Status diferente de Finalizado ou Pendente e também que esteja ativo."
        );
      }
    }
  }

  public avocar(id: number) {

    if(this.selectedModel.arquivoId !== null && this.selectedModel.arquivoId !== undefined){
      return;
    }else{
      const situacao = ERiscosChavesSituacao.Pendente;
      if (this.selectedModel.situacao === ERiscosChavesSituacaoDescricao[situacao] && this.selectedModel.ativo == true){
        this.riscosChavesService.Avocar(id).then(res=>{
          if (res.sucesso) {
            this.exibirMensagemSucesso('Riscos chaves avocado com sucesso.');
          }else {
            this.exibirMensagemAlerta(res.mensagem.descricao);
          }
        }).catch((err) => {
          this.exibirMensagemErro(err.mensagem);
        }).finally(() => {
          this.buscar();
        });
      }
    }
  }
  public isButtonDisabled(): boolean {
    // Verifica se existe um modelo selecionado
    if (!this.selectedModel) {
      return true;
    }
    // Verifica as condições adicionais
    return !this.selectedModel.ativo ||
      !(this.selectedModel.situacao === "Em Elaboração"
        || this.selectedModel.situacao === "Em Elaboração"  ||
        this.selectedModel.situacao === "Em Elaboração"  ||
        this.selectedModel.situacao === "Em preenchimento");
  }
  public excluir(id: number) {

    if(!this.permissoes.excluir){
      this.exibirMensagemErro("Você não possui permissão para Excluir.");
      return;
    }

    this.riscosChavesService
      .excluir(id)
      .then((res) => {
        if (res.sucesso) {
          this.exibirMensagemSucesso('Universo excluído com sucesso.');
        } else {
          this.exibirMensagemAlerta(res.mensagem.descricao);
        }
      })
      .catch((err) => {
        this.exibirMensagemErro(err.mensagem);
      })
      .finally(() => {
        this.buscar();
      });
  }
  public importarArquivo() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'modal-component';
    dialogConfig.width = '650px';
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      router: 'importar-riscos-chaves',
      unidadeGestoraId: this.filtro.unidadeGestoraId

    };

    const modal = this.matDialog.open(ModalSelecaoUniversoAuditavelComponent , dialogConfig );
    modal.afterClosed().subscribe((data) => {
      if(data){
        this.filtroUniverso.pesquisa = data.nomeTipoUniversoAuditavel;
        if(this.filtroUniverso.pesquisa)
          this.universoSelecionado = true;

        this.tipoUniversoId = data.tipoUniversoAuditavelId;
        this.universoAuditavelId = data.id;
      }
    });

  }

  public imprimir(id: number) {
    this.riscosChavesService
      .DownloadArquivo(this.filtro.unidadeGestoraId, id)
      .then((res) => {
        if (
          res &&
          res.dados &&
          typeof res.dados.url === "string" &&
          res.dados.url.trim() !== ""
        ) {
          this.http
            .get(res.dados.url, { responseType: "blob" })
            .subscribe((blob) => {
              const fileName = res.dados.nomeArquivo;
              saveAs(blob, fileName);
            });
        } else {
          this.router.navigate([`imprimir-riscos-chaves/${this.selectedModel.id}`]);
        }
      });
  }


}
